const ActivateIntegration = require('./ActivateIntegration');
const ResetAccount = require('./ResetAccount');

function ContaAzulEvents() {
  ActivateIntegration();
  ResetAccount();
}

module.exports = {
  init: ContaAzulEvents,
  url: /^\/settings\/integracoes\/contaazul/,
}
